import { Coordination as ServerCoordination } from 'server/models/Coordination';
import { CoordinationCardStatus } from './CoordinationCardStatus';
import { CoordinationLocationType } from 'server/enums/CoordinationLocationType';

import { ScheduleDateEntity } from './ScheduleDateEntity';

export * from 'server/models/Coordination';

export class Coordination extends ServerCoordination {
    /** A comparator function for Coordinations. */
    static DisplayOrder(c1 : Coordination, c2 : Coordination) {
        let cmp : number;
        return (cmp = c1.DisplayOrder() - c2.DisplayOrder()) === 0 ?
            // If DisplayOrder matches, fallback to Id for a deterministic sort.
            c1.Id() - c2.Id() :
            cmp;
    }

    // NOTE: AppliesToScheduleDate and all the various MatchesOn... methods are all mirrored in C# in
    // PortCall.Models\CoordinationCards\Coordination.cs. Keep in sync.
    AppliesToScheduleDate(scheduleDate : ScheduleDateEntity) {
        return (
            this.MatchesOnMilestoneType(scheduleDate) &&
            this.MatchesOnLocation(scheduleDate)
        );
    }

    MatchesOnMilestoneType(scheduleDate : ScheduleDateEntity) {
        return this.MilestoneTypes().some(mt => scheduleDate.MilestoneTypeId() === mt.MilestoneTypeId());
    }

    MatchesOnLocation(scheduleDate : ScheduleDateEntity) {
        return (
            this.MatchesOnMainLocation(scheduleDate) &&
            this.MatchesOnRelatedLocation(scheduleDate)
        );
    }

    MatchesOnMainLocation(scheduleDate : ScheduleDateEntity) {
        if (this.IsScopedByMainLocation()) {
            const loc = scheduleDate.CoordinationsMainLocation();
            return !!loc && this.Locations().some(cl => cl.Type() === CoordinationLocationType.Main && cl.LocationId() === loc.Id());
        } else {
            return true;
        }
    }

    MatchesOnRelatedLocation(scheduleDate : ScheduleDateEntity) {
        if (this.IsScopedByRelatedLocation()) {
            const loc = scheduleDate.CoordinationsRelatedLocation();
            return !!loc && this.Locations().some(cl => cl.Type() === CoordinationLocationType.Related && cl.LocationId() === loc.Id());
        } else {
            return true;
        }
    }

    EffectiveStatusLabel(status : CoordinationCardStatus) {
        return this.AltStatusLabels().find(l => l.Status() === status)?.Label() ?? status.DefaultLabel();
    }
}



// WEBPACK FOOTER //
// ./data/models/Coordination.ts